var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"search"}}),(_vm.show)?_c('div',{attrs:{"id":"loading"}},[_c('img',{attrs:{"src":require("@/assets/loading_mzcr.webp"),"width":"75","alt":"Logo"}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }